import React from 'react';
import { DialogProps } from '@material-ui/core';
import { IJournalEquipmentItem } from '../../interfaces';
import BaseJournalEquipmentItemDialog from './BaseJournalEquipmentItemDialog';

interface IProps {
  equipmentItem: IJournalEquipmentItem | null;
  disabled?: boolean;
  onClose(): void;
  onSubmit(newEquipment: IJournalEquipmentItem): void | Promise<void>;
}

const JournalEquipmentItemReplaceDialog: React.FC<IProps & Pick<DialogProps, 'open'>> = ({
  open,
  equipmentItem,
  disabled = false,
  onClose,
  onSubmit,
}) => {
  return (
    <BaseJournalEquipmentItemDialog
      open={open}
      title="Добавление нового оборудования"
      submitButtonText="Сохранить"
      equipmentItem={equipmentItem}
      disabled={disabled}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default JournalEquipmentItemReplaceDialog;
